import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const offeringsRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTIES,
    name: 'PROPERTIES',
    component: () => import('./PropertiesPage.vue'),
    meta: { requiresAuth: true, title: 'Properties' },
  },
  {
    path: routes.SAVED_PROPERTIES,
    name: 'SAVED_PROPERTIES',
    component: () => import('./SavedPropertiesPage.vue'),
    meta: { requiresAuth: true, title: 'Saved Properties' },
  },
]
